(function () {
  if (customElements.get('homepage-customer-reviews-slider')) return;

  class HomepageCustomerReviewsSlider extends HTMLElement {
    connectedCallback() {
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.handleViewportChange = this.updateSlider.bind(this);
      this.handleResize = this.updateSpacing.bind(this);
      this.mobileQuery.addEventListener('change', this.handleViewportChange);
      window.addEventListener('resize', this.handleResize);
      this.updateSlider();
    }

    disconnectedCallback() {
      this.mobileQuery?.removeEventListener('change', this.handleViewportChange);
      window.removeEventListener('resize', this.handleResize);
      this.destroySlider();
    }

    updateSlider() {
      if (this.mobileQuery.matches) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (this.slider || typeof window.Swiper !== 'function') return;

      this.slider = new window.Swiper(this, {
        slidesPerView: 'auto',
        spaceBetween: this.getGap(),
        watchOverflow: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: this.querySelector('.homepage-customer-reviews__pagination'),
          clickable: true
        }
      });
    }

    getGap() {
      const value = parseFloat(getComputedStyle(this).getPropertyValue('--home-reviews-mobile-slide-gap'));
      return Number.isFinite(value) ? value : 16;
    }

    updateSpacing() {
      if (!this.slider) return;
      this.slider.params.spaceBetween = this.getGap();
      this.slider.update();
    }

    destroySlider() {
      if (!this.slider) return;
      this.slider.destroy(true, true);
      this.slider = null;
    }
  }

  customElements.define('homepage-customer-reviews-slider', HomepageCustomerReviewsSlider);
})();
